import React from 'react';
import PropTypes from 'prop-types';
import FormattedCurrency from '@s/FormattedCurrency';
import Translation from "../../../../shared/Translation";
import { TranslationContext } from 'checkout/config/Translations';
import AddTickets from '@v/ticket-picker/components/AddTickets';

const CartInventoryTableProductRow = props => {
    let productName = props.product.productName;
    if (props.product.configurationName !== "") {
        productName += " (" + props.product.configurationName + ")";
    }

    return <div className={"cart-ticket" + (props.loading ? " loading-state__dim" : "")}>
        <div className="cart-ticket__info">
            <div className="cart-ticket__name" role='heading' aria-level='3'> { productName } </div>
            {props.product.fee && +props.product.fee > 0 ? (<div className="cart-ticket__pricing-group">
                <div className="cart-ticket__price">
                    <FormattedCurrency>{ props.product.price }</FormattedCurrency>
                </div>
                <div className="cart-ticket__fee">+ <FormattedCurrency>{ props.product.fee }</FormattedCurrency>
                </div>
            </div>) : null}
        </div>
        <div className="cart-ticket__controls">
          <div className="cart-ticket__quantity">
              <div className="editable-quantity">
                  <AddTickets
                      quantities={props.product.quantities}
                      quantity={props.quantity}
                      disabled={props.loading}
                      onIncrement={props.onIncrement}
                      onDecrement={props.onDecrement}
                      onQuantityInput={props.onQuantityInput}
                  />
              </div>
          </div>
          <div className='cart-ticket__action'>
            <TranslationContext.Consumer>
              {({ t }) => (
                <button
                  className='button--clear button--small'
                  onClick={props.onRemove}
                  aria-label={t('checkout__delete_quantity', {
                    quantity: props.product.quantity,
                    itemName: productName
                  })}
                >
                  <Translation>{'checkout__remove'}</Translation>
                </button>
              )}
            </TranslationContext.Consumer>
          </div>
          <div className="cart-ticket__subtotal">
              <FormattedCurrency>{ props.product.subtotal }</FormattedCurrency>
          </div>
        </div>
    </div>
}

CartInventoryTableProductRow.propTypes = {
    product: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    quantity: PropTypes.any,
};

CartInventoryTableProductRow.defaultProps = {
    loading: false,
    quantity: 0,
}

export default CartInventoryTableProductRow;
